export default "__VITE_ASSET__Dhl1JOnn__"